import { Match, onCleanup, onMount, Switch } from "solid-js"
import { app } from "../store/app"
import { BrowseView } from "./BrowseView"
import { RouteView } from "./RouteView"
import { VehicleView } from "./VehicleView"

function title() {
  if (app.view() === "route" && app.selectedRoute()) {
    return app.selectedRoute()!.route.shortName || app.selectedRoute()!.route.id
  }
  if (app.view() === "vehicle" && app.selectedVehicle()) {
    return app.selectedVehicle()!.routeName || "vehicle"
  }
  return "routes"
}

export function Sidebar() {
  onMount(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && app.sidebarExpanded()) {
        app.setSidebarExpanded(false)
      }
    }
    window.addEventListener("keydown", onKey)
    onCleanup(() => window.removeEventListener("keydown", onKey))
  })

  return (
    <aside id="sidebar">
      <div class="panel-header">
        {app.view() === "browse" ? (
          <div class="brand">
            live<span>:seattle</span>
          </div>
        ) : (
          <button class="icon-btn" title="Back" onClick={() => app.goBack()}>
            ←
          </button>
        )}
        <div class="panel-title">{title()}</div>
        <div class="header-actions">
          <div class="status-pill">
            {app.vehicles().length ? `${app.vehicles().length} live` : "loading"}
          </div>
          <button
            class={`icon-btn${app.sidebarExpanded() ? " active" : ""}`}
            title={app.sidebarExpanded() ? "Show map" : "Expand panel"}
            onClick={() => app.toggleSidebarExpanded()}
          >
            {app.sidebarExpanded() ? "⧉" : "⛶"}
          </button>
        </div>
      </div>

      <Switch>
        <Match when={app.view() === "browse"}>
          <BrowseView />
        </Match>
        <Match when={app.view() === "route"}>
          <RouteView />
        </Match>
        <Match when={app.view() === "vehicle"}>
          <VehicleView />
        </Match>
      </Switch>
    </aside>
  )
}
